import React, { useEffect, useState } from "react";
import SideBar from "../components/SideBar";
import DetailsTopBar from "../components/DetailsTopBar";
import { useNavigate } from "react-router-dom";
import { categoryService } from "../services/categoryService";

function ManageCategory() {
  const navigate = useNavigate();
  const [name, setName] = useState("all");
  const [status, setStatus] = useState("all");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState([]);
  const itemsPerPage = 6;

  const tabs = [
    { key: "category", label: "Category", path: "/manage-category" },
    { key: "subcategory", label: "Sub Category", path: "/manage-subcategory" },
  ];

  useEffect(() => {
    setCurrentPage(1);
  }, [search, name, status]);

  // Fetch categories from API
  useEffect(() => {
    fetchCategories();
  }, [currentPage, search, name, status]);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const params = {
        per_page: itemsPerPage,
        page: currentPage,
        search: search || undefined,
        status: status !== "all" ? status : undefined,
        sort_by: "created_at",
        sort_order: "desc",
      };

      const response = await categoryService.getAllCategories(params);

      if (response.categories) {
        // Map API response to match your existing data structure
        const formattedCategories = response.categories.map((item) => ({
          id: item.id,
          name: item.name,
          slug: item.slug,
          description: item.description,
          thumbnail:
            item.image_url ||
            "https://i.pinimg.com/originals/ec/99/db/ec99dbf221d03cf3c93ea8c0336501a1.jpg",
          images: item.image_url ? [item.image_url] : [],
          subcategories: item.subcategories || [],
          status: item.status,
          created_by: item.created_by,
          created_at: item.created_at,
          updated_at: item.updated_at,
        }));

        setCategory(formattedCategories);
      }
    } catch (error) {
      console.error("Failed to fetch categories:", error);
      alert(error.response?.data?.message || "Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  const filteredCategorie = category.filter((category) => {
    const searchMatch =
      category.name.toLowerCase().includes(search.toLowerCase()) ||
      category.slug.toLowerCase().includes(search.toLowerCase());

    const nameMatch =
      name === "all" || category.name.toLowerCase() === name.toLowerCase();
    const statusMatch =
      status === "all" ||
      category.status.toLowerCase() === status.toLowerCase();

    return searchMatch && nameMatch && statusMatch;
  });

  const totalPages = Math.ceil(filteredCategorie.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedCategory = filteredCategorie.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  // Navigate to details page with member data
  const handleRowClick = (category) => {
    // Pass only the ID to details page
    navigate(`/category-details/${category.id}`);
  };

  const goToCreateAccount = () => {
    navigate("/create-category");
  };

  // Handle delete category
  const handleDelete = async (categoryId, e) => {
    e.stopPropagation();
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await categoryService.deleteCategory(categoryId);
        alert("Category deleted successfully");
        fetchCategories(); // Refresh the list
      } catch (error) {
        alert(error.response?.data?.message || "Failed to delete category");
      }
    }
  };

  // Handle status change
  const handleStatusChange = async (categoryId, currentStatus, e) => {
    e.stopPropagation();
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    try {
      await categoryService.updateCategoryStatus(categoryId, newStatus);
      alert(`Category ${newStatus} successfully`);
      fetchCategories(); // Refresh the list
    } catch (error) {
      alert(error.response?.data?.message || "Failed to update status");
    }
  };

  return (
    <div className="manage-member-layout">
      <SideBar />
      <div className="main-content">
        <div className="header-bar" style={{ border: 0, boxShadow: "none" }}>
          <div className="header-top">
            <h2 className="header-title">Manage Category</h2>
            <button className="action-btn" onClick={goToCreateAccount}>
              + Add New Category
            </button>
          </div>
          <DetailsTopBar tabs={tabs} activeTab="category" />
          <div className="filters">
            {/* <div className="input-group">
              <label>Filter by category:</label>
              <select
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="filter-select"
              >
                <option value="all">All</option>
                {[...new Set(category.map((c) => c.name))].map(
                  (catName, index) => (
                    <option key={index} value={catName.toLowerCase()}>
                      {catName}
                    </option>
                  ),
                )}
              </select>
            </div> */}
            <div className="input-group">
              <label>Filter by status:</label>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="filter-select"
              >
                <option value="all">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="input-group">
              <label>Search:</label>
              <input
                type="text"
                placeholder="Search by name or slug"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="search-input"
               maxLength={20} />
            </div>
          </div>

          {loading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              Loading...
            </div>
          ) : (
            <div className="table-container">
              <table className="member-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Category Name</th>
                    <th>Slug</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedCategory.length > 0 ? (
                    paginatedCategory.map((category, i) => (
                      <tr
                        key={i}
                        onClick={() => handleRowClick(category)}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{category.id}</td>
                        <td>{category.name}</td>
                        <td>{category.slug}</td>
                        <td>
                          <span
                            className={`status ${category.status.toLowerCase()}`}
                          >
                            {category.status}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center" }}>
                        No categories found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination */}
              <div className="pagination">
                <button
                  className="page-btn"
                  onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                >
                  &lt;
                </button>
                {Array.from({ length: totalPages }, (_, i) => (
                  <button
                    key={i}
                    className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  className="page-btn"
                  onClick={() =>
                    setCurrentPage((p) => Math.min(p + 1, totalPages))
                  }
                >
                  &gt;
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ManageCategory;
